import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function PreserveContextRedirect({ to }) {
    const { search, hash } = useLocation();
    return <Navigate to={`${to}${search}${hash}`} replace />;
}
